export const categories = [
  {
    id: 'register-login',
    name: '注册登录',
    icon: 'ri-user-add-line',
    description: '91n.com 账号注册、登录验证、密码找回及账号安全相关指南',
    color: 'primary',
  },
  {
    id: 'feature-guide',
    name: '功能使用',
    icon: 'ri-guide-line',
    description: '91n.com 平台各项核心功能的详细使用教程与操作指引',
    color: 'accent',
  },
  {
    id: 'faq',
    name: '常见问题',
    icon: 'ri-question-answer-line',
    description: '用户在使用 91n.com 过程中遇到的常见问题及官方解答',
    color: 'secondary',
  },
  {
    id: 'announcement',
    name: '平台公告',
    icon: 'ri-notification-3-line',
    description: '91n.com 官方最新动态、版本更新、服务调整等重要通知',
    color: 'primary',
  },
  {
    id: 'security',
    name: '安全指南',
    icon: 'ri-shield-check-line',
    description: '91n.com 账号安全、隐私保护及防范网络风险的详细指导',
    color: 'accent',
  },
];